import React, {
  memo,
} from 'react';
import ActiveRefund from './components/ActiveRefund';
import SynapseMagazine from './components/SynapseMagazine';

const Offers = () => {
  return (
    <React.Fragment>
      <ActiveRefund />
      <SynapseMagazine />
    </React.Fragment>
  );
};

export default memo(Offers);
